import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";
import { v4 as uuid } from "uuid";
import ReactSelect from "react-select";

type Props = {
    label?: string;
    help?: string;
    className?: string;
    options: { label: string; value: string }[];
} & (
    | {
          value?: string;
          onChange?: (value: string) => void;
          isMulti?: false;
      }
    | { value?: string[]; onChange?: (value: string[]) => void; isMulti: true }
);

export function Select({ label, help, value, onChange, className, options, isMulti }: Props) {
    const id = uuid();

    const classNames = {
        control: () => css("control"),
        menuPortal: () => css("menu-portal"),
        input: () => css("input"),
    };

    return (
        <label htmlFor={id} className={css("react-select", className || "")}>
            <span className={css("form-label")}>{label}</span>
            {isMulti ? (
                <ReactSelect
                    classNames={classNames}
                    isMulti
                    inputId={id}
                    options={options}
                    menuPlacement="auto"
                    menuPosition="fixed"
                    onChange={(options) => onChange?.(options.map((option) => option.value))}
                    value={options.filter((option) => value?.includes(option.value))}
                />
            ) : (
                <ReactSelect
                    classNames={classNames}
                    inputId={id}
                    options={options}
                    menuPlacement="auto"
                    menuPosition="fixed"
                    onChange={(option) => onChange?.(option?.value!)}
                    value={options.find((option) => option.value === value)}
                />
            )}
            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}
